<template>
    <v-container class="fill-height">
        <v-row>
            <v-col cols="12" sm="6">
                <h1 class="subtitle-1 grey--text mb-4">Registru de casă</h1>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
                
            </v-col>
        </v-row>
        <v-card style="width: 100%;" class="fixed">
        <v-card-text>
        <v-row>
            <v-col class="d-flex" cols="12" sm="3">
                <date-range-picker
                    ref="picker"
                    v-model="dateRange"
                    
                    :locale-data="localeData"
                >
                    <template #input="picker" style="display: block;">
                        <v-text-field 
                            label="Perioada"
                            :value="selectedPeriod"
                            :dummy="picker"
                            hide-details
                            prepend-icon="mdi-calendar"
                            dense
                        >
                        </v-text-field>
                    </template>
                </date-range-picker>
            </v-col>
            <v-col class="d-flex" cols="12" sm="2">
               <v-checkbox
                v-model="noDatePrinting"
                label="Fără data tipărire raport"
                dense
                hide-details
                style="padding-top: 0; margin-top: 0;"
                ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="2">
                <v-select
                    v-model="managerCompaniesSelected"
                    :items="managerCompanies"
                    label="Companie"
                    item-text="companyName"
                    item-value="id"
                    hide-details
                    dense
                    :error="managerCompaniesSelectedError"
                ></v-select>
            
            </v-col>
            <v-col class="text-right" cols="12" sm="5">
                <v-btn color="success" 
                    @click="getCashRegister"
                    :loading="downloadBtnLoading"
                >Descarcă registru de casă <v-icon right dark>mdi-file-pdf</v-icon></v-btn> <br/> Descarcă în format PDF Registru de casă pentru perioada și agențiile selectate
            </v-col>
        </v-row>
        </v-card-text>
        </v-card>
        
            <v-card style="width: 100%; margin-top: 15px;">
                    <v-card-title style="padding-bottom: 0;">
                        Agenţii
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="9">
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Search"
                                    single-line
                                    hide-details
                                    style="padding-top: 0;"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-checkbox
                                    v-model="onlyActiveShops"
                                    label="Doar cele active"
                                    dense
                                    hide-details
                                    style="padding-top: 0;"
                                ></v-checkbox>
                            </v-col>
                            
                        </v-row>
                    
                    </v-card-text>
                    <v-data-table
                        v-model="selectedShops"
                        :headers="headers"
                        :items="items"
                        class="elevation-1 overflow-y-auto"
                        :loading="tableLoading"
                        :text-loading="tableLoadingText"
                        :search="search"
                        :single-select="singleSelect"
                        show-select
                        :footer-props="{
                                'items-per-page-options': [10, 20, 30, 40, 50]
                            }"
                        :items-per-page="20"
                    >
                    <template v-slot:item.active="{ item }">
                        <v-icon :color="item.active ? 'success':'grey'">mdi-store-outline</v-icon>
                    </template>
                    </v-data-table>
                </v-card>
    </v-container>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    components: { DateRangePicker },
    data: function() {
        return {
            search: '',
            dateRange: {
                startDate: new Date().toISOString().substr(0, 10), 
                endDate: new Date().toISOString().substr(0, 10)
            },
            localeData: {
                format: 'yyyy-mm-dd',
            },
            tableLoading: false,
            tableLoadingText: "Se încarcă... Te rog așteaptă",
            singleSelect: false,
            selectedShops: [],
            noDatePrinting: false,
            downloadBtnLoading: false,
            managerCompaniesSelected: null, 
            managerCompaniesSelectedError: false,
            onlyActiveShops: false,
            headers: [
                {text: 'Status', value: 'active'},
                {text: 'Cod agentie', value: 'codSucursala'},
                {text: 'Agentie', value: 'name'}
            ]
            
        }
    },
    computed: {
        items(){
            if(this.onlyActiveShops){
                return this.$store.getters['getShops'].filter(el => el.active === true );
            }else{
                return this.$store.getters['getShops'];
            }
        },
        selectedPeriod(){
            return this.$moment(this.dateRange.startDate).format('YYYY-MM-DD') + ' - ' + this.$moment(this.dateRange.endDate).format('YYYY-MM-DD');
        },
        managerCompanies(){
            return this.$store.getters['getManagerCompanies'];
        },
    },
    watch: { // select fist item from managerCompanies array if no option is selected (managerCompaniesSelected = null)
        managerCompanies: function() {
            if(!this.managerCompaniesSelected){
                this.managerCompaniesSelected = this.managerCompanies[0].id;
            }
        }
    },
    mounted() {
       
    },
    methods: {
        getCashRegister(){
            let shops = [];
            this.selectedShops.forEach((el)=>{
                shops.push(el.id);
            });

            this.downloadBtnLoading = true;
            this.$store.dispatch('registruDeCasa/getCashRegister', {
                dateFrom: this.$moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                dateTo: this.$moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                shops: shops,
                companyId: this.managerCompaniesSelected,
                noDatePrinting: this.noDatePrinting

            }).then(()=>{
                this.downloadBtnLoading = false;
            });
        },
    },
}
</script>

<style>
.v-data-table {
    max-width: 100%
}
.reportrange-text {
    border: none !important; 
    padding-left: 0 !important;
}
.vue-daterange-picker {
    display: block !important;
    width: 100% !important;
}
</style>